import { IContactAggNameResponse } from 'shared';

import { CacheTags } from '../../types/cacheTags';
import { emptySplitApi } from '../baseApi';

export const aggNamesApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchAggNames: builder.query<IContactAggNameResponse, { organisationId: string }>({
      query: ({ organisationId }) => ({
        url: `contact/aggregateNames`,
        method: `GET`,
        headers: {
          [`X-Organisation-Id`]: organisationId,
        },
      }),
      providesTags: [{
        type: CacheTags.ContactAggNames,
      }],
    }),
  }),
});

export const {
  useFetchAggNamesQuery,
} = aggNamesApi;
